import { apiClient } from '@/core/api/client';
import { ENDPOINTS } from '@/core/api/endpoints';
import { DashboardPromotorSchema, DashboardResumenSchema, } from '@/data/dto/dashboard';
export const dashboardApi = {
    async resumen(fecha, balanceDias = 7) {
        const params = { balanceDias };
        if (fecha)
            params.fecha = fecha;
        const res = await apiClient.get(ENDPOINTS.dashboard, { params });
        return DashboardResumenSchema.parse(res.data);
    },
    async promotor(fecha) {
        const res = await apiClient.get(ENDPOINTS.dashboardPromotor, {
            params: fecha ? { fecha } : undefined,
        });
        return DashboardPromotorSchema.parse(res.data);
    },
};
